import { render, staticRenderFns } from "./asset-plugin-info.vue?vue&type=template&id=1f49931b&"
import script from "./asset-plugin-info.vue?vue&type=script&lang=js&"
export * from "./asset-plugin-info.vue?vue&type=script&lang=js&"
import style0 from "./asset-plugin-info.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports